import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { assign } from 'lodash';

function DefaultHeaderComponent({ displayName }) {
  return <span>{displayName}</span>;
}

/**
 * @todo
 * The quality this component is poor, and should be revisted in future improvement work.
 */
class GridTitle extends Component {
  constructor(props) {
    super(props);

    this.sort = this.sort.bind(this);
    this.toggleSelectAll = this.toggleSelectAll.bind(this);
    this.handleSelectionChange = this.handleSelectionChange.bind(this);
  }

  sort(column) {
    return () => {
      this.props.sortSettings.changeSort(column);
    };
  }

  toggleSelectAll() {
    this.props.multipleSelectionSettings.toggleSelectAll();
  }

  handleSelectionChange() {}

  render() {
    let titleStyles = {};

    const nodes = this.props.columnSettings.getColumns().map((col) => {
      let defaultTitleStyles = {};
      let columnSort = '';
      const columnIsSortable =
        this.props.columnSettings.getMetadataColumnProperty(
          col,
          'sortable',
          true
        );
      let sortComponent = columnIsSortable
        ? this.props.sortSettings.sortDefaultComponent
        : null;

      if (
        this.props.sortSettings.sortColumn === col &&
        this.props.sortSettings.sortDirection === 'asc'
      ) {
        columnSort = this.props.sortSettings.sortAscendingClassName;
        sortComponent =
          this.props.useGriddleIcons &&
          this.props.sortSettings.sortAscendingComponent;
      } else if (
        this.props.sortSettings.sortColumn === col &&
        this.props.sortSettings.sortDirection === 'desc'
      ) {
        columnSort += this.props.sortSettings.sortDescendingClassName;
        sortComponent =
          this.props.useGriddleIcons &&
          this.props.sortSettings.sortDescendingComponent;
      }

      const meta = this.props.columnSettings.getColumnMetadataByName(col);
      const displayName = this.props.columnSettings.getMetadataColumnProperty(
        col,
        'displayName',
        col
      );

      const hideColumnName =
        this.props.columnSettings.getMetadataColumnProperty(
          col,
          'hideColumnName',
          false
        );

      const HeaderComponent =
        this.props.columnSettings.getMetadataColumnProperty(
          col,
          'customHeaderComponent',
          DefaultHeaderComponent
        );

      columnSort =
        meta == null
          ? columnSort
          : ((columnSort && `${columnSort} `) || columnSort) +
            this.props.columnSettings.getMetadataColumnProperty(
              col,
              'cssClassName',
              ''
            );

      if (this.props.useGriddleStyles) {
        defaultTitleStyles = {
          backgroundColor: '#EDEDEF',
          border: '0px',
          borderBottom: '1px solid #DDD',
          color: '#222',
          padding: '5px',
          cursor: columnIsSortable ? 'pointer' : 'default',
        };
      }
      titleStyles =
        meta && meta.titleStyles
          ? assign({}, defaultTitleStyles, meta.titleStyles)
          : assign({}, defaultTitleStyles);

      const ComponentClass = displayName ? 'th' : 'td';
      let sortComponentDisplay;
      sortComponentDisplay = columnIsSortable ? ' Sortable ' : '';
      return (
        <ComponentClass
          role="gridcell"
          data-title={col}
          className={columnSort}
          key={col}
          style={titleStyles}
        >
          <label
            className="header-table"
            onClick={columnIsSortable ? this.sort(col) : null}
            aria-label={`${displayName}${sortComponentDisplay}`}
          >
            {!hideColumnName && (
              <HeaderComponent
                columnName={col}
                displayName={displayName}
                filterByColumn={this.props.filterByColumn}
              />
            )}
            <span aria-hidden="true">{sortComponent} </span>
          </label>
        </ComponentClass>
      );
    });

    if (nodes && this.props.multipleSelectionSettings.isMultipleSelection) {
      nodes.unshift(
        <th
          scope="col"
          key="selection"
          onClick={this.toggleSelectAll}
          className="selection-column"
        >
          <div className="option-select" key="selection">
            <input
              type="checkbox"
              id="grid-title-select-all-checkbox"
              name="checkbox"
              checked={this.props.multipleSelectionSettings.getIsSelectAllChecked()}
              onChange={this.handleSelectionChange}
            />
            <label htmlFor="grid-title-select-all-checkbox">
              <span className="sr-only">Select all</span>
            </label>
          </div>
        </th>
      );
    }

    // Get the row from the row settings.
    const className =
      (this.props.rowSettings &&
        this.props.rowSettings.getHeaderRowMetadataClass()) ||
      null;
    return (
      <thead>
        <tr role="row" className={className} style={this.props.headerStyles}>
          {nodes}
        </tr>
      </thead>
    );
  }
}

GridTitle.defaultProps = {
  columnSettings: null,
  filterByColumn: () => {},
  rowSettings: null,
  sortSettings: null,
  multipleSelectionSettings: null,
  headerStyle: null,
  useGriddleStyles: true,
  useGriddleIcons: true,
  headerStyles: {},
};

GridTitle.propTypes = {
  multipleSelectionSettings: PropTypes.object,
  columnSettings: PropTypes.object.isRequired,
  sortSettings: PropTypes.object.isRequired,
  headerStyles: PropTypes.object,
};

export { GridTitle };
